'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _style = require('./style');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ConditionEditor(props) {
  var Editor = props.Editor,
      schema = props.schema,
      onChange = props.onChange;

  return _react2.default.createElement(
    'div',
    { className: _style2.default.searchField, role: 'alert' },
    _react2.default.createElement(
      'span',
      { className: _style2.default.searchName },
      schema.name,
      '\uFF1A'
    ),
    _react2.default.createElement(Editor, _extends({}, props, { style: _style2.default })),
    _react2.default.createElement(
      'button',
      {
        type: 'button',
        className: 'close',
        'aria-label': 'Close',
        style: { padding: 5 },
        onClick: function onClick() {
          return onChange({});
        }
      },
      _react2.default.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      )
    )
  );
}
ConditionEditor.propTypes = {
  Editor: _propTypes.func.isRequired,
  onChange: _propTypes.func.isRequired,
  schema: _propTypes.object.isRequired
};

exports.default = ConditionEditor;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/QueryEditor/ConditionEditor/ConditionEditor.js
// module id = 1668
// module chunks = 0